import { Box } from '@mui/joy';
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { MapProvider } from '@vis.gl/react-maplibre';

import { BackendMap } from '@/components/backend/BackendMap';
import { ReportsTable } from '@/components/backend/reports-table/ReportsTable';
import { makeMetaTitle } from '@/modules/META';
import { backendApiAdminLevelsFindOneOptions } from '@/modules/api/@tanstack/react-query.gen';
import { useReportsTableStore } from '@/stores/useReportsTableStore';
import { ReportsTableMode } from '@/types/ReportsTableState';

export const Route = createFileRoute('/verwaltung/{-$adminLevelId}/meldungen')({
  ssr: false,
  head: async ({
    params: { adminLevelId },
    match: {
      context: { queryClient },
    },
  }) => {
    if (adminLevelId) {
      const adminLevel = await queryClient.ensureQueryData(
        backendApiAdminLevelsFindOneOptions({ path: { adminLevelId } }),
      );

      return {
        meta: [makeMetaTitle([`Meldungen ${adminLevel.name}`])],
      };
    }

    return {
      meta: [makeMetaTitle(['Meldungen'])],
    };
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: RouteComponent,
});

function RouteComponent() {
  const mode = useReportsTableStore((state) => state.mode);

  return (
    <MapProvider>
      <Box sx={{ flex: 1, display: 'flex', position: 'relative' }}>
        <ReportsTable />
        {mode !== ReportsTableMode.TABLE && <BackendMap />}
      </Box>

      <Outlet />
    </MapProvider>
  );
}
